import {Component, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-policy-management',
  templateUrl: './policy-management.component.html',
  styleUrls: ['./policy-management.component.scss']
})
export class PolicyManagementComponent implements OnInit {
  uploadForm: FormGroup;
  fileVersions: any[] = [];
  fileName: string;
  policyFileTypes = Object.keys(PolicyFileType);

  constructor(private http: HttpClient, private formBuilder: FormBuilder) {
    this.uploadForm = this.formBuilder.group({
      file: [''],
      type: ['']
    });
  }

  ngOnInit(): void {
    this.search();
  }

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('file').setValue(file);
    }
  }

  submit(): void {
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('file').value);
    formData.append('type', this.uploadForm.get('type').value);

    this.http.post(`${environment.backendApiUrl}/v1/policies/upload`, formData).subscribe(response => {
      console.log(response);
      this.search();
    });
  }

  search(): void {
    this.http.get<any[]>(`${environment.backendApiUrl}/v1/policies`).subscribe(data => {
      this.fileVersions = data;
    });
  }
}

export enum PolicyFileType {
  TERMS_OF_USE = 'TERMS_OF_USE',
  TERMS_OF_USE_WEB = 'TERMS_OF_USE_WEB',
  PRIVACY_POLICY = 'PRIVACY_POLICY'
}
